import { render, staticRenderFns } from "./natural.vue?vue&type=template&id=769a8f20&scoped=true"
import script from "./natural.vue?vue&type=script&lang=js"
export * from "./natural.vue?vue&type=script&lang=js"
import style0 from "./natural.vue?vue&type=style&index=0&id=769a8f20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769a8f20",
  null
  
)

export default component.exports